import { render, staticRenderFns } from "./FailureEmailTab.vue?vue&type=template&id=9010b6e4&scoped=true&"
import script from "./FailureEmailTab.vue?vue&type=script&lang=js&"
export * from "./FailureEmailTab.vue?vue&type=script&lang=js&"
import style0 from "./FailureEmailTab.vue?vue&type=style&index=0&id=9010b6e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9010b6e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
